module.exports = __webpack_public_path__ + "static/media/empty.d15ad54e.svg";